import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        esvBible: true,
        currentPage: 'home',
        oldTSelected: true,
        currentVerse: '',
        oldTBookname: '',
        newTBookname: '',
        loggedIn: false,
        searchBy: 'verse',
        userId: '',
        loading: false,
        favouritesLoaded: false,
        favouritesDetails: null
    },
    getters: {
        getFavouritesLoadedState: state => {
            return state.favouritesLoaded;
        },
        getFavouritesDetails: state => {
            return state.favouritesDetails;
        },
        getLoadingState: state => {
            return state.loading;
        },
        getSearchByState: state => {
            return state.searchBy;
        },
        getEsvState: state => {
            return state.esvBible;
        },
        getCurrentPage: state => {
            return state.currentPage;
        },
        getUserId: state => {
            return state.userId;
        },
        getLoggedInState: state => {
            return state.loggedIn;
        },
        getOldTSelected: state => {
            return state.oldTSelected;
        },
        getCurrentVerse: state => {
            return state.currentVerse;
        },
        getOldTestamentBookName: state => {
            return state.oldTBookname;
        },
        getNewTestamentBookName: state => {
            return state.newTBookname;
        }
    },
    mutations: {
        setFavouritesLoadedState: (state, bool) => {
            state.favouritesLoaded = bool;
        },
        setFavouritesDetails: (state, payload) => {
            state.favouritesDetails = payload;
        },
        setLoadingState: (state, bool) => {
            state.loading = bool;
        },
        setSearchBy: (state, target) => {
            state.searchBy = target;
        },
        setBibleVersion: (state) => {
            state.esvBible = !state.esvBible;
        },
        updateCurrentPage: (state, page) => {
            state.currentPage = page;
        },
        setUserId: (state, token) => {
            state.userId = token;
        },
        setLoggedIn: (state, bool) => {
            state.loggedIn = bool;
        },
        updateOldTSelected: (state) => {
            state.oldTSelected = !state.oldTSelected;
        },
        updateCurrentVerse: (state, bookUrl) => {
            state.currentVerse = bookUrl;
        },
        updateOldTestamentBookName: (state, bookName) => {
            state.oldTBookname = bookName;
        },
        updateNewTestamentBookName: (state, bookName) => {
            state.newTBookname = bookName;
        }
    },
    actions: {
        setFavouritesLoadedState: ({ commit }, bool) => {
            commit('setFavouritesLoadedState', bool);
        },
        setFavouritesDetails: ({ commit }, payload) => {
            commit('setFavouritesDetails', payload);
        },
        setLoadingState: ({ commit }, bool) => {
            commit('setLoadingState', bool);
        },
        setSearchBy: ({ commit }, target) => {
            commit('setSearchBy', target);
        },
        setBibleVersion: ({ commit }) => {
            commit('setBibleVersion');
        },
        updateCurrentPage: ({ commit }, page) => {
            commit('updateCurrentPage', page);
        },
        setUserId: ({ commit }, token) => {
            commit('setUserId', token);
        },
        setLoggedIn: ({ commit }, bool) => {
            commit('setLoggedIn', bool);
        },
        updateOldTSelected: ({ commit }) => {
            commit('updateOldTSelected');
        },
        updateCurrentVerse: ({ commit }, bookUrl) => {
            commit('updateCurrentVerse', bookUrl);
        },
        updateOldTestamentBookName: ({ commit }, bookName) => {
            commit('updateOldTestamentBookName', bookName);
        },
        updateNewTestamentBookName: ({ commit }, bookName) => {
            commit('updateNewTestamentBookName', bookName);
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js